import Vue from 'vue'

export const newsletters = {
    state: {
        newsletters: null,
        newsletterDetails: null,
        status: 'idle',
        detailsStatus: 'idle',
        pagination: null,
        sortOptions: [
            {
                query: 'PUBLICATION_DATE',
                label: 'Data dodania'
            },
            {
                query: 'EXPIRE_DATE',
                label: 'Data wygaśnięcia'
            },
            {
                query: 'TITLE',
                label: 'Nazwa'
            }
        ],
        sort: {
            by: 'PUBLICATION_DATE',
            direction: 'desc'
        },
        filters: {
            keywords: {
                type: 'search-input',
                value: '',
                searchParamsTooltip: ['tytule', 'treści']
            }
        },
        searchResultCount: {
            current: null,
            archival: null
        },
        total: null
    },
    mutations: {
        SET_NEWSLETTERS(state, payload) {
            state.newsletters = payload
        },
        SET_NEWSLETTERS_DETAILS(state, payload) {
            state.newsletterDetails = payload
        },
        SET_NEWSLETTERS_STATUS(state, payload) {
            state.status = payload
        },
        SET_NEWSLETTERS_DETAILS_STATUS(state, payload) {
            state.detailsStatus = payload
        },
        SET_NEWSLETTERS_PAGINATION(state, payload) {
            state.pagination = payload
        },
        SET_NEWSLETTERS_SORT(state, payload) {
            state.sort = payload
        },
        SET_NEWSLETTERS_SEARCH_RESULT_COUNT(state, payload) {
            state.searchResultCount = payload
        },
        SET_NEWSLETTERS_TOTAL(state, payload) {
            state.total = payload
        },
        SET_NEWSLETTERS_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        }
    },
    actions: {
        async loadNewsletters({ state, commit, dispatch }, payload) {
            try {
                commit('SET_NEWSLETTERS_STATUS', 'loading')
                const toAppend = payload.append
                delete payload.append

                const params = {
                    ...payload,
                    sorting: state.sort.by,
                    direction: state.sort.direction,
                    keywords: state.filters.keywords.value || undefined,
                    type: 'NEWSLETTER'
                }
                const res = await dispatch('fetchAnnouncements', params)

                if (toAppend) {
                    commit('SET_NEWSLETTERS', [
                        ...state.newsletters,
                        ...res.data.data.news
                    ])
                } else {
                    commit('SET_NEWSLETTERS', res.data.data?.news)
                }
                commit('SET_NEWSLETTERS_PAGINATION', res.data.data.resultSet)

                if (state.filters.keywords.value) {
                    const searchRes = await dispatch('fetchAnnouncements', {
                        ...params,
                        archival: !params.archival
                    })
                    const resCount = res.data.data.resultSet.total
                    const searchResCount = searchRes.data.data.resultSet.total
                    commit('SET_NEWSLETTERS_SEARCH_RESULT_COUNT', {
                        current: params.archival ? searchResCount : resCount,
                        archival: params.archival ? resCount : searchResCount
                    })
                } else {
                    dispatch('resetNewslettersSearchResultCount')
                }
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_NEWSLETTERS_STATUS', 'idle')
            }
        },
        async loadNewsletterDetails({ state, commit, dispatch }, payload) {
            try {
                commit('SET_NEWSLETTERS_DETAILS_STATUS', 'loading')

                const params = {
                    ...payload,
                    type: 'NEWSLETTER'
                }
                const res = await dispatch('fetchAnnouncements', params)

                commit('SET_NEWSLETTERS_DETAILS', res.data.data?.news[0])
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_NEWSLETTERS_DETAILS_STATUS', 'idle')
            }
        },
        setNewslettersSort({ commit }, payload) {
            commit('SET_NEWSLETTERS_SORT', payload)
        },
        resetNewslettersSearchResultCount({ state, commit }) {
            if (
                state.searchResultCount.archival > -1 ||
                state.searchResultCount.current > -1
            ) {
                commit('SET_NEWSLETTERS_SEARCH_RESULT_COUNT', {
                    current: null,
                    archival: null
                })
            }
        },
        async markNewsletterAsRead({ getters }, { id, unread }) {
            await this.$api.patch(
                `users/${getters.userId}/announcements/${id}?unread=${unread}`
            )
        },
        async fetchNewslettersTotal({ commit, getters }) {
            try {
                const { data, status } = await this.$api.post(
                    `users/${getters.userId}/announcements`,
                    {
                        limit: 1,
                        deleted: false,
                        archival: false,
                        read: false,
                        type: 'NEWSLETTER'
                    }
                )

                if (status !== 200 || !data?.data) {
                    throw new Error(data.message || 'Error fetchNewslettersTotal')
                }

                commit('SET_NEWSLETTERS_TOTAL', data.data.resultSet.total)
            } catch (err) {
                console.log(err)
            }
        }
    },
    getters: {
        getNewsletters: state => state.newsletters,
        getNewsletterDetails: state => state.newsletterDetails,
        getNewslettersStatus: state => state.status,
        getNewsletterDetailsStatus: state => state.detailsStatus,
        getNewslettersPagination: state => state.pagination,
        getNewslettersSortOptions: state => state.sortOptions,
        getNewslettersSort: state => state.sort,
        getNewslettersSearchResultCount: state => state.searchResultCount,
        getNewslettersTotal: state => state.total,
        getNewslettersFilters: state => state.filters
    }
}
